define('rest/trafficViewport',["http", "security", "./utils"],
    function (http, security, utils) {
        "use strict";
        return {
            trafficViewport: function (options, callback) {
                var pathParams = {};
                var queryParams = {};
                queryParams.key = utils.or(options.key, security.getKey("services/traffic"));
                var baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/");
                var serviceUrl = utils.or(options.serviceUrl, "traffic/services/4/incidentViewport/0,0,.1,.1/0/0,0,.1,.1/0/false/{contentType}");
                http.get({
                    url: baseUrl + serviceUrl,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    fail: options.fail
                });
            }
        };
    }
);

